import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class MapControlEffects {
  constructor(readonly actions$: Actions) {}
}
